import { ProjectMethodology } from 'components/ProjectMethodology';
import type { ProjectMethodologyEnum } from 'gql/graphql';
import type { BreadcrumbsPropOnItemClick, DefaultItemBreadcrumbs } from 'uikit';
import { Breadcrumbs, cnMixSpace } from 'uikit';

import type { PropsWithChildren } from 'react';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Styles from './CatalogPageLayout.module.css';

interface ICatalogPageLayoutProps {
    title: string | undefined;
    methodology: ProjectMethodologyEnum | ProjectMethodologyEnum[];
}

export const CatalogPageLayout = ({ title, methodology, children }: PropsWithChildren<ICatalogPageLayoutProps>) => {
    const navigate = useNavigate();

    const methodologies = useMemo(() => {
        if (Array.isArray(methodology)) {
            return methodology;
        }

        return methodology ? [methodology] : [];
    }, [methodology]);

    const pages = useMemo<DefaultItemBreadcrumbs[]>(
        () => [
            {
                label: 'Реестр справочников',
                href: '/catalogs',
            },
            {
                label: title ?? '',
            },
        ],
        [title],
    );

    const handleBreadcrumbsItemClick = useCallback<BreadcrumbsPropOnItemClick<DefaultItemBreadcrumbs>>(
        ({ e, item }) => {
            e.preventDefault();

            if (typeof item.href !== 'undefined') {
                navigate(item.href);
            }
        },
        [navigate],
    );

    return (
        <>
            <div className={cnMixSpace({ mH: 'xl', mT: 'xl' })}>
                <Breadcrumbs items={pages} onItemClick={handleBreadcrumbsItemClick} size="xs" />
                <div className={Styles.title}>
                    <h2>{title}</h2>

                    {methodologies.map((item) => (
                        <ProjectMethodology key={item} className={cnMixSpace({ mL: 's' })} methodology={item} />
                    ))}
                </div>
            </div>
            {children}
        </>
    );
};

CatalogPageLayout.displayName = 'CatalogPageLayout';
